import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleDotted = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-circle-dotted",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			d: "M0 0h24v24H0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M7.5 4.21l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.21 7.5l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M4.21 16.5l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M7.5 19.79l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 21l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.5 19.79l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.79 16.5l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M21 12l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.79 7.5l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M16.5 4.21l0 .01" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 3l0 .01" })
	]
});
const ForwardRef = forwardRef(SvgCircleDotted);
export default ForwardRef;
